import { getBackendBaseUrl } from "./apiConfig";

/**
 * Helper to construct a proper, robust URL for uploaded documents, images, and files.
 */
export const getFileUrl = (path, apiUrl = getBackendBaseUrl()) => {
  if (!path) return null;
  if (typeof path !== "string") return null;
  const trimmed = path.trim();
  if (!trimmed) return null;
  if (
    trimmed.startsWith("http://") ||
    trimmed.startsWith("https://") ||
    trimmed.startsWith("blob:") ||
    trimmed.startsWith("data:")
  ) {
    return trimmed;
  }

  // Safely strip only the trailing /api from API_URL without corrupting domains like https://api.soloway.lk/api
  const baseUrl = (apiUrl || "").replace(/\/api\/?$/, "");

  // Normalize backslashes to forward slashes
  let cleanPath = trimmed.replace(/\\/g, "/").replace(/\/+/g, "/");

  // Ensure leading slash
  if (!cleanPath.startsWith("/")) {
    cleanPath = `/${cleanPath}`;
  }

  // Ensure /uploads prefix if it's a file name
  if (!cleanPath.startsWith("/uploads/")) {
    if (cleanPath.startsWith("/uploads")) {
      cleanPath = cleanPath.replace(/^\/uploads/, "/uploads/");
    } else {
      cleanPath = `/uploads${cleanPath}`;
    }
  }

  // Collapse any remaining double slashes in path
  cleanPath = cleanPath.replace(/\/+/g, "/");

  return `${baseUrl}${cleanPath}`;
};

export const docUrl = getFileUrl;
export const imageUrl = getFileUrl;
